<template>
    <v-dialog v-model="carga" :max-width="tamModal" :scrollable="$root.isTouch == false" :fullscreen="$root.isTouch"
        persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="tituloFormulario"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" :lazy-validation="false">
                    <v-container fluid grid-list-sm>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="seleccionado.idTipoPersona" :rules="requeridoRegla"
                                    :items="listaTipoPersona" item-text="tipoPersona" item-value="idTipoPersona"
                                    label="Contratante" outlined dense color="textbox"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" v-if="!tipoPersonaNatural">
                                <v-text-field v-model="seleccionado.nombreCompleto" :rules="requeridoRegla"
                                    label="Nombre Contratante" outlined dense color="textbox"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" v-if="tipoPersonaNatural">
                                <v-text-field v-model="seleccionado.nombreContratante" :rules="requeridoRegla"
                                    label="Nombre" outlined dense color="textbox"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" v-if="tipoPersonaNatural">
                                <v-text-field v-model="seleccionado.apellidoContratante" :rules="requeridoRegla"
                                    label="Apellido" outlined dense color="textbox"></v-text-field>
                            </v-col>
                            <v-col cols="12" :sm="tipoPersonaNatural ? 4 : 6">
                                <v-text-field v-model="seleccionado.numeroDocumento" :rules="requeridoRegla"
                                    label="Número Identificación" outlined dense color="textbox"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="seleccionado.telefonoCelular" :rules="requeridoRegla"
                                    :mask="'(###) ### - ####'" label="Teléfono Celular" outlined dense color="textbox">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="seleccionado.telefonoPBX" :rules="requeridoRegla"
                                    label="Teléfono PBX" outlined dense color="textbox" :mask="'(###) ### ###'">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="seleccionado.email" :rules="_.concat(requeridoRegla,emailRegla)"
                                    label="Correo" outlined dense color="textbox">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <span class="headline" v-html="'Dirección'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="seleccionado.idProvincia"
                                    :rules="requeridoRegla" @change="onListarCanton"
                                    :items="listaGeneral.provincia" label="Provincia" outlined dense
                                    color="textbox"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="seleccionado.idCanton"
                                    :rules="requeridoRegla" @change="onListarParroquia"
                                    :items="listaGeneral.canton" item-text="canton"
                                    item-value="idCanton" label="Canton" outlined dense
                                    color="textbox">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="seleccionado.idParroquia"
                                    :rules="requeridoRegla" :items="listaGeneral.parroquia"
                                    item-text="parroquia" item-value="idParroquia" label="Parroquia"
                                    outlined dense color="textbox"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="seleccionado.idSector"
                                    :rules="requeridoRegla" :items="listaGeneral.sector"
                                    item-text="sector" item-value="idSector" label="Sector" outlined
                                    dense color="textbox"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="seleccionado.direccion"
                                    :rules="requeridoRegla" label="Dirección" outlined dense
                                    color="textbox"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <span class="headline" v-html="'Datos de la Empresa'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="seleccionado.nombreComercial"
                                    :rules="requeridoRegla" label="Nombre Comercial" outlined dense
                                    color="textbox"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <span class="headline" v-html="'Contribuyente Especial'"></span>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="seleccionado.nombreContribuyenteEspecial"
                                    :rules="requeridoRegla" label="Nombre Contribuyente Especial"
                                    outlined dense color="textbox">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="text-right mt-3 mb-3">
                                <v-btn outlined rounded color="danger"
                                    @click="cerrarFormulario(), $refs.form.resetValidation()" class="mr-1">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="guardar()">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalContratanteComponent',
        props:{
            carga:{type: Boolean, default: false},
            seleccionado:{type: Object, default: {}},
            tituloFormulario:{type: String, default: ''},
            listaGeneral:{type: Object, default: {}},
            listaEstado:{type: Array, default: () => []},
            listaTipoPersona:{type: Array, default: () => []},
        },
        inject: ['insertarActualizar', 'cerrarFormulario'],
        data: () => ({
            date: new Date().toISOString().substr(0, 10),
            fechaActual: moment().format('YYYY-MM-DD'),
            fechaVigenciaDesdeDatePicker: false,
            fechaVigenciaHastaDatePicker: false,
            fechaEmisionDatePicker: false,
        }),
        watch:{
            carga(val){
                if(!_.isUndefined(this.$refs.form))
                    this.$refs.form.resetValidation();
            }
        },
        computed: {
            tipoPersonaNatural(){
                if(_.toNumber(_.get(this.listaGeneral,'idPersonaNatural',-1)) == _.toNumber(_.get(this.seleccionado,'idTipoPersona',-2)))
                    return true;
                else
                    return false;
            },
        },
        methods: {
            seguroSeleccionado() {
                var selec = this.seleccionado.idSeguro,
                    objeto = _.find(this.listaGeneral.seguro, function (o) {
                        return o.idSeguro == selec;
                    });
                this.seleccionado.naturaleza = objeto.naturaleza;
                this.seleccionado.regulacion = objeto.regulacion;
            },
            onListarCanton(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'L',
                        idProvincia: this.seleccionado.idProvincia,
                        idEstado: _.get(this.seleccionado, 'estado', 1)
                    };

                    var error = 'E';
                    this.listaGeneral.canton = [];

                    axios.post(`${BASE_URI}administrador/canton/listar`, objeto)
                        .then((r) => {
                            if (r.status != '200') throw mensajeEstandar.errorPeticion;
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion); };
                                this.listaGeneral.canton = r.data.data;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        });
                }
            },
            onListarParroquia(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'LC',
                        idCanton: this.seleccionado.idCanton
                    };

                    var error = 'E';
                    this.listaGeneral.parroquia = [];

                    axios.post(`${BASE_URI}administrador/parroquia/listar`, objeto)
                        .then((r) => {
                            if (r.status != '200') throw mensajeEstandar.errorPeticion;
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data','data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion); };
                                this.listaGeneral.parroquia = r.data.data;
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error)
                        });
                }
            },
            guardar() {
                try {
                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                        this.insertarActualizar((this.seleccionado.idPoliza > "0") ? "U" : 'I');
                    
                } catch (error) {
                    mensajesAlerta(error,'I');
                }
            },
        }
    }
</script>